import TextCell from './TextCell';
import StatusCell from './StatusCell';
import PersonCell from './PersonCell';
import DateCell from './DateCell';
import SelectCell from './SelectCell';
import NumberCell from './NumberCell';
import CurrencyCell from './CurrencyCell';
import CheckboxCell from './CheckboxCell';
import LinkCell from './LinkCell';
import CreatedCell from './CreatedCell';

export default function CellRenderer({ column, value, statusOptions, users, onChange, card, readOnly = false }) {
  if (column.type === 'created' || column.type === 'updated') {
    return <CreatedCell card={card} mode={column.type} />;
  }
  switch (column.type) {
    case 'text':
      return <TextCell value={value} onChange={onChange} readOnly={readOnly} />;
    case 'status':
      return <StatusCell value={value} column={column} statusOptions={statusOptions || []} onChange={onChange} readOnly={readOnly} />;
    case 'person':
      return <PersonCell value={value} users={users} onChange={onChange} readOnly={readOnly} />;
    case 'date':
      return <DateCell value={value} column={column} onChange={onChange} readOnly={readOnly} />;
    case 'number':
      return <NumberCell value={value} onChange={onChange} readOnly={readOnly} />;
    case 'currency':
      return <CurrencyCell value={value} decimals={column.config?.decimals} onChange={onChange} readOnly={readOnly} />;
    case 'select':
      return <SelectCell value={value} column={column} config={column.config || {}} onChange={onChange} readOnly={readOnly} />;
    case 'checkbox':
      return <CheckboxCell value={value} onChange={onChange} readOnly={readOnly} />;
    case 'link':
      return <LinkCell value={value} onChange={onChange} readOnly={readOnly} />;
    default:
      return <TextCell value={value} onChange={onChange} readOnly={readOnly} />;
  }
}
